// extracted by mini-css-extract-plugin
export default {"wrapper":"auth_wrapper__fXhZA","form":"auth_form__hm-My","inp":"auth_inp__bOAeR","btn":"auth_btn__mZH-S"};